<template>
  <div class="contact d-flex align-center justify-center">
    <div class="contact-content d-flex f-column align-center justify-center">
      <h3>联系我们</h3>
      <p>Contact us</p>
      <div class="main d-flex">
        <div class="main-left flex-1">
          <div class="d-flex">
            <span class="iconfont icon-qiyejianzhudasha"></span>
            <span class="text">国农（重庆）生猪大数据产业发展有限公司</span>
          </div>
          <div class="d-flex">
            <span class="iconfont icon-dianhua"></span>
            <span class="text">023-81068886</span>
          </div>
          <!-- <div class="d-flex">
            <span class="iconfont icon-youxiang"></span>
            <span class="text">00000000@00.com</span>
          </div> -->
          <div class="d-flex">
            <span class="iconfont icon-dizhi"></span>
            <span class="text"
              >重庆市荣昌区昌州街道灵方大道19号1幢9-1</span
            >
          </div>
          <el-image
            class="image"
            :src="require('@/assets/images/about_qr.jpg')"
          ></el-image>
          <div class="qr-text">关注微信公众号</div>
        </div>
        <div class="main-right flex-1">
          <baidu-map
            class="bm-view"
            ak="e18dwXvVSlU62nwMv0L6LT9vjZL37oZX"
            :scroll-wheel-zoom="scrollWheelZoom"
            :center="center"
            :zoom="zoom"
            @ready="handler"
          >
            <BmMarker :position="position" />
          </baidu-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
export default {
  components: {
    BaiduMap,
    BmMarker
  },
  data() {
    return {
      center: '重庆市荣昌区',
      zoom: 3,
      scrollWheelZoom: true,
      position: { lng: 0, lat: 0 },
      markerIcon: {
        url: require('@/assets/images/marker.png'),
        size: {
          width: 30,
          height: 30
        }
      }
    }
  },
  created() {
  },
  methods: {
    handler({ BMap, map }) {
      this.center = '重庆市荣昌区灵方大道19号创新发展中心'
      // this.center.lat = 39.915
      this.zoom = 18.5
      this.position.lng = '105.601418'
      this.position.lat = '29.411308'
    }
  }
}
</script>

<style lang="scss" scoped>
.contact {
  padding-top: 0.875rem;
  padding-bottom: 1.225rem;
  &-content {
    h3 {
      font-size: 0.45rem;
      padding-bottom: 0.375rem;
    }
    p {
      text-transform: uppercase;
      font-size: 0.2rem;
      color: #666;
      margin-bottom: 0.825rem;
    }
    .main {
      width: 15rem;
      &-left {
        height: 5.75rem;
        background-color: #f9fafe;
        padding: 0.625rem 1rem;
        font-size: 0.1875rem;
        color: #999;
        .iconfont {
          padding-right: 0.125rem;
          line-height: 0.5rem;
          font-size: 0.25rem;
          color: #c9c9cb;
        }
        .text {
          line-height: 0.5rem;
        }
        .image {
          display: block;
          width: 1.375rem;
          height: 1.375rem;
          margin: 0.125rem 0;
        }
      }
      &-right {
        height: 5.75rem;
        .bm-view {
          width: 100%;
          height: 5.75rem;
        }
        ::v-deep .anchorBL {
          display: none;
        }
      }
    }
  }
}
</style>
